module.exports = __webpack_public_path__ + "static/media/cessione_credito.70dcf4c5.md";